import { render, staticRenderFns } from "./Score.vue?vue&type=template&id=1f9ad836"
import script from "./Score.vue?vue&type=script&lang=js"
export * from "./Score.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports